module.exports = __webpack_public_path__ + "img/xx.6613aa65.svg";